export default __webpack_public_path__ + "static/media/recoil-blog.c3ae1b47.svg";